import { render, staticRenderFns } from "./PermissionManage.vue?vue&type=template&id=cfefe422&scoped=true"
import script from "./PermissionManage.vue?vue&type=script&lang=js"
export * from "./PermissionManage.vue?vue&type=script&lang=js"
import style0 from "./PermissionManage.vue?vue&type=style&index=0&id=cfefe422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfefe422",
  null
  
)

export default component.exports